module.exports = __webpack_public_path__ + "static/media/04.fc8f7ecc.webp";